/**
 * Copyright (C) Techniserv, spol. s r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import ArticleRated from './articleRated/main.js';
import IsArticleUseful from './isArticleUseful/main.js';
import sendRatingRequest from './utils/sendRatingRequest.js';

export default function ArticleFeedback({
	articleId,
  groupId,
  companyId,
  feedbackSendUrl,
  feedbackUpdateUrl,
	namespace
}) {
  const rootElement = document.getElementById(`${namespace}articleFeedback`)

  if (typeof(Storage) !== 'undefined') {
    const storageKey = `jcz_afw_${companyId}_${groupId}_${articleId}`
    const storedDataJson = localStorage.getItem(storageKey)
    if (storedDataJson) {
      rootElement.append(ArticleRated({
        rating: getStoredDataOrNull(storedDataJson),
        namespace
      }))
    } else {
      rootElement.append(IsArticleUseful({
        sendRatingRequest: function({rating}){
          sendRatingRequest({articleId, rating, sendEndpoint: feedbackSendUrl, updateEndpoint: feedbackUpdateUrl, namespace, storageKey})
        },
        namespace
      }))
    }
  } else {
    console.log('Disabling AirticleFeedback. Storage not supported by browser.')
  }

  return {
    dispose() {}
  }
}

function getStoredDataOrNull(json) {
  try {
    return JSON.parse(json)
  } catch (e) {
    console.error('Failed to parse stored article feedback. JSON invalid.', e)
    return null;
  }
}
